<template>
    <div class="location-wrap">
        <div class="location">
            <ul class="inner">
                <li class="home">
                    <a href="/en/index.do"><img src="@/assets/resource/images/icon/icon_home.png" alt=""></a>
                </li>
                <!-- <li class="back">
                    <a href="javascript:history.back();" class="btn_back"><span class="blind_lab">이전페이지 이동</span></a>
                </li> -->
                
                <template v-for="(path, idx) in currentMenuPath">
                    <li :class="`dep_${idx + 1} select_action`" v-if="idx < 2">                       
                        <template v-if="idx == 0">
                            <a href="javascript:void(0);" @click="selectActive(idx)">
                                <span class="txt">{{currentMenuParent.menuName}}</span><em class="icon_select_round"></em>
                            </a>
                            <ul class="con" @click="selectOff">
                                <li v-for="(menu, j) in depth1">
                                    <a href="javascript:;" v-if="menu.mypageYn == mypageYn" @click="$goMenu(menu)">{{menu.menuName}}</a>
                                </li>                               
                            </ul>
                        </template>
                        <template v-if="idx == 1">
                            <template v-for="(menu, i) in this.currentMenuParent.childs">
                                <a v-if="menu.menuNo == path" href="javascript:void(0);" @click="selectActive(idx)">
                                    <span class="txt">{{menu.menuName}}</span><em class="icon_select_round"></em>
                                </a>
                            </template>
                            <ul class="con" @click="selectOff">
                                <!-- SSO회원여부에 따라서 회원정보메뉴 노출처리하기 -->
                                <li v-for="(child, k) in this.currentMenuParent.childs">
                                    <a href="javascript:;" v-if="!(child.menuName == '회원정보' && $store.state.loginTypeStore.ssoMember) && child.menuNo != '1321' && child.menuNo != '1464'" @click="$goMenu(child), selectActive()">{{child.menuName}}</a>
                                </li>
                            </ul>
                        </template>
                    </li>
                </template>          
                
                <template v-for="(path, idx) in currentMenuPath" v-if="this.depth2.childs && this.depth2.childs.length > 0">
                    <li :class="`dep_3 select_action`" v-if="idx == 2">                                            
                        <template v-for="(menu, i) in this.depth2.childs">
                            <a v-if="menu.menuNo == path" href="javascript:void(0);" @click="selectActive(idx)">
                                <span class="txt">{{menu.menuName}}</span><em class="icon_select_round"></em>
                            </a>
                        </template>
                        <ul class="con" @click="selectOff">
                            <li v-for="(child, k) in this.depth2.childs">
                                <a href="javascript:;" @click="$goMenu(child)">{{child.menuName}}</a>
                            </li>
                        </ul>
                    </li>
                </template>          
            </ul>
        </div>
    </div>
</template>

<script>
import { el } from "date-fns/locale";

const lodash = require("lodash");
export default {
    data() {
        return {
            locationMenuList : [],
            currentMenu : null,
            currentMenuPath: [],
            currentMenuParent : [],
            depth1: [], // depth 별 리스트
            depth2: [],
            // depth3: [],
            // depth2List: [], // depth2, 3에 나열할 리스트
            // depth3List: [],

            // 변경후
            locaNo: 0,
            oneName: '',
            twoName: '',
            threeName: '',

            // location depth active
            isDepth1Active : false,
            isDepth2Active : false,
            isDepth3Active : false,
            mypageYn : 'N'
        }
    },
    watch: {
        $route(to, from) {
            if (to.href != from.href) {
                this.getLocation();
            }
        }
    },
    methods: {
        // url 복사
        clip() {
            let url = '';
            const textarea = document.createElement("textarea");
            document.body.appendChild(textarea);
            url = window.document.location.href;
            textarea.value = url;
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            alert("해당 페이지 링크가 복사되었습니다.")
        },
        getLocation(){    
            //Content URL로 나의 메뉴 찾기
            let routePath = this.$route.path.replace("/view", '/list');            

            if(this.$route.query.category){ 
                routePath += '?category=' + this.$route.query.category; 
            } 

            for (let i = (this.menuList.length - 1); i > 0; i--) {
                if(this.menuList[i].menuUrl === routePath){
                    this.currentMenu = this.menuList[i];
                    break;
                }           
            }

            try {
                //현재 Page의 mypage여부 확인
                this.mypageYn = this.currentMenu.menuUrl.includes('/mypage/') ? 'Y' : 'N';

                if(this.currentMenu){
                    this.currentMenuPath = this.currentMenu.pathMenu.split('-');
                    for (let i = 0; i < this.depth1.length; i++) {
                        if (this.depth1[i].menuNo == this.currentMenuPath[0]) {
                            this.currentMenuParent = this.depth1[i];
                            break;
                        }
                    }    

                    if(this.currentMenuParent && this.currentMenuParent.childs){
                        for (let i = 0; i < this.currentMenuParent.childs.length; i++) {
                            if (this.currentMenuParent.childs[i].menuNo == this.currentMenuPath[1]) {
                                this.depth2 = this.currentMenuParent.childs[i];
                                break;
                            }
                        }            
                    }
                }
            } catch (error) {
                console.error('메뉴정보 없음.');
            }
        },
        init(){        
            this.depth1 = [];
            this.locationMenuList = lodash.cloneDeep(this.menuList);
            for (let i = 0; i < this.locationMenuList.length; i++) {                            
                this.locationMenuList[i].childs = [];
                this.locationMenuList[i].mypageYn = this.locationMenuList[i].menuUrl.includes('/mypage/') ? 'Y' : 'N';
            }

            //부모찾기
            for (let i = 0; i < this.locationMenuList.length; i++) {
                if(this.locationMenuList[i].gnbYn !== 'T' && this.locationMenuList[i].parentMenuNo !== 0){
                    for (let j = 0; j < this.locationMenuList.length; j++) {
                        if(this.locationMenuList[i].parentMenuNo == this.locationMenuList[j].menuNo){                            
                            this.locationMenuList[j].childs.push(this.locationMenuList[i]);
                        }
                    }
                }
            }      
                 
            for (let i = 0; i < this.locationMenuList.length; i++) {
                if (this.locationMenuList[i].depth == 1 && (this.locationMenuList[i].gnbYn == 'Y' || this.locationMenuList[i].mypageYn == 'Y')) {
                    this.depth1.push(this.locationMenuList[i]);
                }
            }       
        },
        selectActive(i) {
            let selectActTime = 400;

            if ($('.select_action:eq(' + i + ')').hasClass('active') == false) {
                $('.select_action').removeClass('active');
                $('.select_action').find('.con').stop().slideUp(selectActTime);
                if (i == 0) {
                    $('.dep_1').addClass('active');
                    $('.dep_1').find('.con').stop().slideDown(selectActTime); //내리는부분
                }
                if (i == 1) {
                    $('.dep_2').addClass('active');
                    $('.dep_2').find('.con').stop().slideDown(selectActTime); //내리는부분
                }
                if (i == 2) {
                    $('.dep_3').addClass('active');
                    $('.dep_3').find('.con').stop().slideDown(selectActTime); //내리는부분
                }
            } else {
                $('.select_action:eq(' + i + ')').removeClass('active');
                $('.select_action:eq(' + i + ')').find('.con').stop().slideUp(selectActTime);

            }
        },
        selectOff() {
            $('.select_action > .con').slideUp();
        }
    },
    mounted() {
        this.getLocation();

        // 외부영역 클릭시 로케이션바 닫기
        $(document).mouseup(function (e) {
            //select 닫기
            let selectShow = $('.select_action');
            if (selectShow.has(e.target).length === 0) {
                $('.select_action .con').stop().slideUp(400);
                $('.select_action').removeClass('active');
            }
        });
    },
    created() {
        this.init();
    },
}
</script>

<style>

</style>